import React, { useEffect, useState } from "react";
import LmsHeader from "../component/lmsHeader/lmsHeader";
import {
  CREATE_COURSE,
  COURSES,
  LESSON,
  ACCESS_DENIED,
  COURSES_SCORM,
} from "../../../constant/routeContant";
import { useSelector, useDispatch } from "react-redux";
import * as lmsAction from "../../../redux/actions/lmsAction";
import {
  GRID_DEFAULT_PAGE_SIZE,
  ORG_ID,
  USER_ID,
  API_STATUS,
  USER_TYPE,
} from "../../../constant/constant";
import { checkPrivileges } from "../../../utils/rolesHelper";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import Loader from "../../../library/common/Loader";
import CoursescormList from "../component/coursescormList/coursescormList";
import * as userAction from "../../../redux/actions/userAction";
import { useDebounce } from "../../../utils/useDebounceSearch";
import { getUserBaseDivisionInfo } from "../../../utils/helper";

const CoursescormContainer = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  let navigate = useNavigate();
  const { hasBaseDivisionAdminAccess, baseDivisionIds } =
    getUserBaseDivisionInfo();

  const [sendEmail, setSendEmail] = useState(false);
  const [publicStatus, setPublicStatus] = useState(false);
  const [isdisable, setisdisable] = useState(false);
  const [iscloneBtnClick, setIscloneBtnClick] = useState(false);
  const [isSubmitAssign, setisSubmitAssign] = useState(false);
  const [comsucces, setComsucces] = useState(false);
  const [checkcoursestatus, setcheckcoursestatus] = useState(false);
  const [defaultCourseTab] = useState(() =>
    location?.state?.defaultCourseTab !== undefined
      ? location.state.defaultCourseTab
      : 0,
  );
  const [assignmsg, setAssignmsg] = useState(false);
  const [opens, setOpens] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);

  const publishCourseDetail = useSelector((state) => state.publishCourse);
  const courseListData = useSelector((state) => state.getCoursesList);
  const cloneCourseData = useSelector((state) => state.cloneCourseData);
  const allUsers = useSelector((state) => state.allUsers?.data?.users);
  const publishCourseStatus = useSelector(
    (state) => state.publishCourse.status,
  );
  const categoryListData = useSelector((state) => state.getCategoryList?.data);

  const CompleteCourseStatusResult = useSelector(
    (state) =>
      state.getCompletedCourseStatuscheck?.dataresult?.completedCourseList,
  );
  const CompleteCourseStatusStatus = useSelector(
    (state) => state.getCompletedCourseStatuscheck?.status,
  );
  const showLoader = useSelector(
    (state) =>
      state.getCategoryList?.isLoading ||
      state.cloneCourseData?.isLoading ||
      state.publishCourse?.isLoading ||
      state.assignCourse?.isLoading ||
      state.getCompletedCourseStatuscheck?.isLoading ||
      state.getUserGroupDetsilsData.isLoading,
  );
  const assignCourserResult = useSelector((state) => state.assignCourse);
  const assigncourseStatus = assignCourserResult?.status;
  const allGroups = useSelector((state) => state.searchAllGroup);
  const isLoadingGroup = useSelector(
    (state) => state.searchAllGroup?.isLoading,
  );
  const AlluserisLoading = useSelector((state) => state.allUsers?.isLoading);
  const [dataConfirm, setDataConfirm] = useState(null);
  const [scromConfirmationOpen, setScromConfirmationOpen] = useState(false);
  const getUserGroupDetsilsData = useSelector(
    (state) => state.getUserGroupDetsilsData,
  );
  const [usersGroup, setUsersGroup] = useState("");
  const [groupSearchText, setGroupSearchText] = useState("");
  const [userSearchText, setUserSearchText] = useState("");

  const debouncedGroupSearchText = useDebounce(groupSearchText, 500);
  const debouncedUserSearchText = useDebounce(userSearchText, 500);

  // above states and selectocts=====================================================================//

  const dataHeader = React.useMemo(
    () => ({
      title: "Training Management",
      btnLink: CREATE_COURSE,
      scromhelpText:
        "These courses are pay-per-use and may require approval from your company administrator. Your enrollment and completion will be tracked and billed to your company.",
      menu: [
        { route: LESSON, text: "Lessons" },
        { route: COURSES, text: "Courses" },
        { route: COURSES_SCORM, text: "Marketplace" },
      ],
    }),
    [],
  );
  const getStatusCheckCoursecompleted = (data) => {
    dispatch(lmsAction.getCompletedCourseStatuscheck(data));
  };

  const getCoursesListData = (data) => {
    if (data?.isSendMail) {
      setSendEmail(true);
    } else {
      setSendEmail(false);
    }
    dispatch(lmsAction.getCoursesList(data));
  };
  const getategoryListData = (data) => {
    dispatch(lmsAction.getCategoryList(data));
  };
  const deleteCourse = (data) => {
    dispatch(lmsAction.deleteCourse(data));
  };

  function searchUsers(searchText, type, divisionId) {
    const scopedDivisionId = hasBaseDivisionAdminAccess
      ? baseDivisionIds
      : (divisionId ?? 0);
    dispatch(userAction.searchAllUsers(searchText, type, scopedDivisionId));
  }

  const cloneCourse = (data) => {
    setIscloneBtnClick(true);
    dispatch(lmsAction.cloneCourse(data));
  };
  function handleAllGroupSearch(serachText, divisionId, alldivision) {
    const scopedDivisionId = hasBaseDivisionAdminAccess
      ? baseDivisionIds
      : (divisionId ?? 0);
    dispatch(
      userAction.searchAllGroup(
        serachText,
        scopedDivisionId,
        hasBaseDivisionAdminAccess ? false : alldivision,
      ),
    );
  }
  const getUserGroupDetail = (groupId) => {
    dispatch(userAction.getUserGroupDetails(groupId));
  };

  const groupUserCount =
    getUserGroupDetsilsData?.data?.result?.userIds?.length || 0;

  const defaultData = {
    pageNumber: 1,
    pageSize: GRID_DEFAULT_PAGE_SIZE,
    search: "",
    catIds: "",
    userId: USER_ID(),
    organisationId: ORG_ID(),
    status: defaultCourseTab === 0 ? "" : defaultCourseTab,
    isSendMail: false,
    isScorm: true,
  };

  useEffect(() => {
    const isAllowedDash = checkPrivileges([12, 11, 10]);

    if (isAllowedDash === false) {
      navigate(ACCESS_DENIED);
    }
    getCoursesListData(defaultData);
    dispatch(lmsAction.clearPublishCourse());
    dispatch(lmsAction.clearCategoryList());
    dispatch(lmsAction.clearDeleteLesson(""));
    setUsersGroup("");
  }, []);
  useEffect(() => {
    if (location?.state?.defaultCourseTab !== undefined) {
      const { defaultCourseTab: _defaultCourseTab, ...rest } =
        location.state ?? {};
      navigate(location.pathname, {
        replace: true,
        state: Object.keys(rest).length ? rest : null,
      });
    }
  }, [location?.state, location?.pathname, navigate]);
  useEffect(() => {
    if (courseListData?.status === API_STATUS.SUCCESS && sendEmail) {
      toast("Courses has been sent to registered email ID");
    }
  }, [courseListData]);
  useEffect(() => {
    if (
      publishCourseDetail?.data?.responseMessages?.responseCode === "HBNG017" &&
      publicStatus
    ) {
      toast(publishCourseDetail?.data?.responseMessages?.responseMessage);
    }
  }, [publishCourseDetail]);

  useEffect(() => {
    if (CompleteCourseStatusResult?.length > 0) {
      setcheckcoursestatus(true);
    } else {
      setcheckcoursestatus(false);
    }
  }, [CompleteCourseStatusResult]);

  useEffect(() => {
    dispatch(lmsAction.clearAssigncourseStatus());
    setisSubmitAssign(false);
    setComsucces(false);
  }, []);
  useEffect(() => {
    if (assigncourseStatus === API_STATUS.SUCCESS) {
      setIsSubmit(false);
      setAssignmsg(true);
      const timeout = setTimeout(() => {
        setAssignmsg(false);
      }, 2000);
      setDataConfirm(null);
      setScromConfirmationOpen(false);
      return () => clearTimeout(timeout);
    } else {
      setAssignmsg(false);
    }
  }, [assigncourseStatus]);
  useEffect(() => {
    const data = {
      pageNumber: 1,
      isGlobal: "",
      status: true,
    };
    getategoryListData(data);
  }, []);
  useEffect(() => {
    const grouptext = debouncedGroupSearchText || "";
    const divId = hasBaseDivisionAdminAccess ? baseDivisionIds : 0;
    dispatch(
      userAction.searchAllGroup(
        grouptext,
        divId,
        hasBaseDivisionAdminAccess ? false : true,
      ),
    );
  }, [debouncedGroupSearchText]);

  useEffect(() => {
    const usertext = debouncedUserSearchText || "";
    const divId = hasBaseDivisionAdminAccess ? baseDivisionIds : 0;
    dispatch(userAction.searchAllUsers(usertext, USER_TYPE.ALL, divId));
  }, [debouncedUserSearchText]);
  return (
    <>
      {showLoader && <Loader />}
      <LmsHeader dataHeader={dataHeader} />
      <ToastContainer />
      <CoursescormList
        publishCourseStatus={publishCourseStatus}
        courseListData={courseListData}
        getCoursesListData={getCoursesListData}
        categoryListData={categoryListData}
        deleteCourse={deleteCourse}
        setisdisable={setisdisable}
        isdisable={isdisable}
        cloneCourse={cloneCourse}
        cloneCourseData={cloneCourseData}
        toast={toast}
        iscloneBtnClick={iscloneBtnClick}
        setIscloneBtnClick={setIscloneBtnClick}
        setPublicStatus={setPublicStatus}
        getategoryListData={getategoryListData}
        tableClass={"increaseHeight"}
        defaultTabValue={defaultCourseTab}
        setcheckcoursestatus={setcheckcoursestatus}
        checkcoursestatus={checkcoursestatus}
        completeCourseStatusResult={CompleteCourseStatusResult}
        completeCourseStatusStatus={CompleteCourseStatusStatus}
        onSearch={searchUsers}
        allUsers={allUsers}
        setisSubmitAssign={setisSubmitAssign}
        getStatusCheckCoursecompleted={getStatusCheckCoursecompleted}
        isSubmitAssign={isSubmitAssign}
        assignmsg={assignmsg}
        handleAllGroupSearch={handleAllGroupSearch}
        userGroups={allGroups?.data?.groupList}
        isLoadingGroup={isLoadingGroup}
        setOpens={setOpens}
        opens={opens}
        assigncourseStatus={assigncourseStatus}
        AlluserisLoading={AlluserisLoading}
        isSubmit={isSubmit}
        setIsSubmit={setIsSubmit}
        setDataConfirm={setDataConfirm}
        dataConfirm={dataConfirm}
        setScromConfirmationOpen={setScromConfirmationOpen}
        scromConfirmationOpen={scromConfirmationOpen}
        setUsersGroup={setUsersGroup}
        groupUserCount={groupUserCount}
        usersGroup={usersGroup}
        getUserGroupDetail={getUserGroupDetail}
        onGroupSearchChange={setGroupSearchText}
        onUserSearchChange={setUserSearchText}
      />
    </>
  );
};

export default CoursescormContainer;
